require('./ctxNotification.style.scss');

class CtxNotificationService {
    constructor($filter, toaster, $state, $rootScope, $timeout) {
        this.$filter = $filter;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.toaster = toaster;
        this.transFilter = this.$filter('translate');
        this.settings = {
            'limit': 3, // limits max number of toasts
            'tap-to-dismiss': true,
            'close-button': true,
            'close-html': '<button class="toast-close-button" type="button"><i class="icon-error"></i></button>',
            'newest-on-top': true,
            'time-out': 5000,
            'icon-classes': {
                error: 'toast-error',
                info: 'toast-info',
                wait: 'toast-wait',
                in_progress: 'toast-wait',
                success: 'toast-success',
                ok: 'toast-success',
                warning: 'toast-warning',
                warn: 'toast-warning'
            },
            // 'body-output-type': 'template', // Options: '', 'trustedHtml', 'template', 'templateWithData', 'directive'
            // 'body-template': 'ctxNotification.template.html',
            // 'icon-class': 'toast-info',
            'position-class': 'toast-top-center', // Options (see CSS):
            // 'toast-top-full-width', 'toast-bottom-full-width', 'toast-center',
            // 'toast-top-left', 'toast-top-center', 'toast-top-right',
            // 'toast-bottom-left', 'toast-bottom-center', 'toast-bottom-right',
            'title-class': 'toast-title',
            'message-class': 'toast-message',
            'prevent-duplicates': false,
            'mouseover-timer-stop': true // stop timeout on mouseover and restart timer on mouseout
        };
    }

    pop(message) {
        if (!message) return;
        this.toaster.pop({
            type: message.type ? message.type.toLowerCase() : '',
            // title: this.$filter('translate')(message.title),
            // body: this.$filter('translate')(message.details),
            title: message.title,
            body: message.details,
            clickHandler: (toast, isCloseButton) => {
                if (isCloseButton) return true;
                if (message.redirectParams && message.redirectParams.taskUuid) {
                    this.$rootScope.$broadcast('closeModal');
                    this.$timeout(() => {
                        this.$state.go('app.jobs', { jobUuid: message.redirectParams.taskUuid });
                    }, 200);
                    return true;
                }
                if (message.redirectParams && message.redirectParams.eventUuid) {
                    this.$rootScope.$broadcast('closeModal');
                    this.$timeout(() => {
                        this.$state.go('app.events', { eventUuid: message.redirectParams.eventUuid });
                    }, 200);
                    return true;
                }
            }
        });
        return this.toaster.toast;
    }

    getConfig() {
        return this.settings;
    }

    clearAll() {
        this.toaster.clear();
    }

    clearToastInstance(toastInstance) {
        if (!toastInstance || !toastInstance.toastId) return;
        this.toaster.clear(toastInstance)
    }
}
CtxNotificationService.$inject = ['$filter', 'toaster', '$state', '$rootScope', '$timeout'];

module.exports = CtxNotificationService;


// WEBPACK FOOTER //
// ./src/shared/ctxNotification/ctxNotification.service.js